<template>
    <div class="page">
        <img class="banner" src="@/assets/images/banner.png" alt="">
        <div class="content">
            <div class="top">
                <img class="shopimg" :src="shopIcon" alt="">
                <div class="title">
                    <h1>水果商城</h1>
                    <p>送货+自提，新鲜水果新商城</p>
                </div>
                <div class="downLoad">
                    <div v-for="(item,index) in allCodes" class="allcodes">
                        <div class="codes">
                            <img :src="item.icon" alt="">
                            {{item.name}}
                        </div>
                        <img class="code" :src="item.hovercode" alt="">
                    </div>
                    <!-- <div>
                        <img src="@/assets/images/ios.png" alt="">
                        iOS下载</div> -->
                </div>
                <!-- <div class="downLoad">
                    <div><img src="@/assets/images/small-program.png" alt="">
                        小程序</div>
                    <div><img src="@/assets/images/wechat-w.png" alt="">
                        微信公众号</div>
                </div> -->
            </div>
            <div class="feature">
                <div class="shop" v-for="(item,index) in features" >
                    <img :src="item.icon" alt="">
                    <p>{{item.text}}</p>
                </div>
            </div>
            <p class="life">水果商城，让你的生活丰富起来</p>
            <div class="detail">
                <div class="more">
                    <img class="bg" src="@/assets/images/bg1.png" alt="">
                    <div class="introduce">
                        <p class="title">连通线上线下的多功能商城</p>
                        <p>服务于线下品牌连锁门店的线上购物商城，线上平台展示门店商品，各种门店活动线上推送，
                        力求最快传达用户所有的商品详细信息，为用户提供一个健康便捷的多功能购物平台。</p>
                        <p>利用零散时间线上选购商品，不占用您的多余时间，在家——我们给您送货，在外面——我们等您进店自提。</p>
                        <p>多功能商城，不止多一种选择。</p>
                        <div class="pic">
                            <div>
                                <img src="@/assets/images/location-m.png" alt="">
                                <p>门店定位</p>
                            </div>
                            <div>
                                <img src="@/assets/images/location-y.png" alt="">
                                <p>用户定位</p>
                            </div>
                            <div>
                                <img src="@/assets/images/function.png" alt="">
                                <p>多功能选购</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="price">
                    <img class="bg" src="@/assets/images/bg2.png" alt="">
                    <div class="introduce">
                        <p class="title">品质商品超低价，随时选购带回家</p>
                        <p>社区拼团，限时抢购等多种活动每日上新，移动端一键购买轻松方便，
                            用户先订购，平台再送货，安全品质不含糊。</p>
                        <p>品质生活，可以省着过。</p>
                        <div class="pic">
                            <div>
                                <img src="@/assets/images/assemble.png" alt="">
                                <p>拼团邀请</p>
                            </div>
                            <div>
                                <img src="@/assets/images/details.png" alt="">
                                <p>活动详情</p>
                            </div>
                            <div>
                                <img src="@/assets/images/coupon.png" alt="">
                                <p>领优惠券</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="shopcode">
                <p class="title">水果商城——多端服务，一端操作</p>
                <div class="codes">
                    <div class="code" v-for="(item,index) in allCodes">
                        <img :src='item.code' alt="">
                        <p>{{item.name}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部组件 -->
        <v-footer></v-footer>
    </div>
</template>

<script>
import footer from '@/components/footer.vue'
export default {
    
    name:'index',
    data(){
        return{
            shopIcon:require('@/assets/images/logo.png'),
            features:[
                {
                    icon:require('@/assets/images/shop.png'),
                    text:'门店商城',
                },
                {
                    icon:require('@/assets/images/location.png'),
                    text:'智能定位',
                },
                {
                    icon:require('@/assets/images/delivery.png'),
                    text:'免费配送',
                },
                {
                    icon:require('@/assets/images/service.png'),
                    text:'进店服务',
                }
            ],
            allCodes:[
                {
                    icon:require('@/assets/images/android.png'),
                    code:require('@/assets/images/QXzr.png'),
                    hovercode:require('@/assets/images/hovercode.png'),
                    name:'android下载',
                },
                {
                    icon:require('@/assets/images/ios.png'),
                    code:require('@/assets/images/QXzr.png'),
                    hovercode:require('@/assets/images/hovercode.png'),
                    name:'iOS下载',
                },
                {
                    icon:require('@/assets/images/small-program.png'),
                    code:require('@/assets/images/QXzr.png'),
                    hovercode:require('@/assets/images/hovercode.png'),
                    name:'小程序',
                },
                {
                    icon:require('@/assets/images/wechat-w.png'),
                    code:require('@/assets/images/QXzr.png'),
                    hovercode:require('@/assets/images/hovercode.png'),
                    name:'微信公众号',
                },
            ]
        }
    },
    components:{
        'v-footer':footer
    }
}
</script>


<style>
.page{
    width: 100%;
    /* min-width: 1750px; */
}
.banner{
    width: 100%;
    position: absolute;
    z-index: -100;
    left: 0;
    /* height: 780px; */
    /* min-width: 1750px; */
}
.content{
    /* width: 100%; */
    padding: 1vw 15%;
}
.top{
    position: relative;
    padding: 0 0 1vw;
    color: #fff;
}
.top .shopimg{
    position: absolute;
    width: 11vw
}
.title h1{
    font-size: 4vw;
    letter-spacing: 0.2rem;
    margin:1vw 0 0;
    padding-top: 7vw;
}
.title p{
    font-size: 2VW;
    letter-spacing: 6px;
    margin: 10px 0 10px;
}
.downLoad{
    display: flex;
    margin-bottom: 6vw;
    font-size: 1.3vw;
    width: 50%;
    flex-wrap: wrap;
    text-align: left
}
.downLoad .allcodes{
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 2vw;
    flex-basis: 50%;
    
}
.downLoad .codes{
    width: 70%;
    padding: 0.1rem;
    background-color: #f7a35d;
    border-radius: 10px;
    box-shadow: 0px 14px 40px rgba(0,138,154,0.4);
    display: flex;
    align-items: center
}
.downLoad .codes:hover+img{
    opacity: 1;
    z-index: 100;
}
.downLoad div img{
    width: 15%;
    margin-right: 10px;
}
/* .downLoad .codes:nth-child(2n+1){
    margin-right: 80px;
} */
.downLoad .code{
    position: absolute;
    top: 0;
    left: 15vw;
    width: 14vw;
    height: 14vw;
    z-index:  -100;
    opacity: 0;
    transition: opacity 1s ease-out,z-index 0.01s ease-in-out;
}
.feature{
    display: flex;
    justify-content: space-between;
    padding: 1vw 0px;
    position: relative;
    top: -1vw;
    margin-bottom: 3vw;
}
.feature .shop{
    flex-shrink: 0;
    /* margin-right: 20px; */
    padding-top: 4%;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0px 14px 40px rgba(0, 138, 154, 0.2);
    flex-basis: 23%;
    text-align: center;
    color: #333;

}
.feature .shop p{
    margin: 1.5vw 0 2vw;
    font-size: 1.6vw
}
.feature .shop img{
    width: 60%;
    padding: 0.2rem 0.2rem 0;
    /* height: 70%; */
}
.life{
    text-align: center;
    color: #333;
    font-size: 2vw;
    margin-bottom: 2vw;
}
.detail{
    color: #fff;
    font-size: 1vw;
}
.more .introduce{
    /* width: 500px; */
    padding: 4.5vw 0 0 36vw;
    text-align: right;
}
.introduce .title{
    font-size: 1.6vw;
    margin-bottom: 1.5vw;
}
.introduce p{
    font-size: 0.9vw;
    line-height: 2vw;
}
.more ,.price {
    /* position: relative; */
    /* height: 660px; */
    /* left: -380px;
    z-index: -100; */
    height: 33vw;
}
.bg{
    position: absolute;
    left: 0;
    z-index: -100;
    /* height: 660px; */
    width: 100%;
    /* min-width: 1750px; */
}
.introduce .pic{
    /* width: 4vw; */
    margin-top: 1.5vw;
    display: flex;
    justify-content:flex-end
}
.more .pic div{
    margin-left: 1vw;
    text-align: center;
    flex-basis: 25%;
}
.price .introduce{
    padding-top: 7vw;
    width: 30vw;
}
.price .title{
    margin-bottom: 2vw;
}
.price .pic{
    margin-top: 5vw;
    justify-content: start
}
.pic img{
    /* width: 1vw */
    width: 50%;
}
.price .pic div{
    margin-right: 1vw;
    text-align: center;
    flex-basis: 25%;
}
.shopcode .title{
    margin: 6vw 0 3vw 0;
    font-size: 2vw;
    text-align: center;
}
.shopcode .codes{
    display: flex;
    justify-content: space-around;
    text-align: center;
    font-size: 20px;
    margin-bottom: 2vw;
}
.codes .code{
    flex-basis: 20%;
    font-size: 1vw;
}
.code img{
    width: 50%
}
</style>






// WEBPACK FOOTER //
// src/pages/index.vue